import { iamAppUserMembershipFields } from '../iam-app-user/iam-app-user.queries';
import { gql } from 'graphql-tag';

export const iamGroupFields = `
  id
  accountId
  name
  status
  description
  memberCount
  supervisorCount
`;

export const iamGroupDetailFields = `
  ${iamGroupFields}
  members {
    ${iamAppUserMembershipFields}
  }
`;

export const getIamGroupsResponseFields = `
  totalCount
  groups {
    ${iamGroupFields}
  }
`;

export const getIamGroupsQuery = gql`
  query searchGroups($input: SearchGroupsInput!) {
    searchGroups(input: $input) {
      ${getIamGroupsResponseFields}
    }
  }
`;

export const getIamGroupByIdQuery = gql`
  query getGroup($input: GetGroupInput!) {
    getGroup(input: $input) {
      ${iamGroupDetailFields}
    }
  }
`;

export const createIamGroupMutation = gql`
  mutation createGroup($input: CreateGroupInput!) {
    createGroup(input: $input) {
      ${iamGroupFields}
    }
  }
`;

export const updateIamGroupMutation = gql`
  mutation updateGroup($input: UpdateGroupInput!) {
    updateGroup(input: $input) {
      ${iamGroupFields}
    }
  }
`;

export const deleteIamGroupMutation = gql`
  mutation deleteGroup($input: DeleteGroupInput!) {
    deleteGroup(input: $input) {
      ${iamGroupDetailFields}
    }
  }
`;
